import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { TourEligibleServiceDao } from '../../../../db-models/tour-dao';
import { CustomBookingMessageTemplate } from '../../../../db-models/widget-conf-dao';
import { TourServiceCardComponent } from '../tour-service-card/tour-service-card.component';

export interface TourCategoryGroup {
  id: number;
  name: string;
  position: number;
  services: TourEligibleServiceDao[];
}

@Component({
  selector: 'app-tour-service-list',
  templateUrl: './tour-service-list.component.html',
  styleUrls: ['./tour-service-list.component.scss'],
  imports: [TranslateModule, TourServiceCardComponent, FaIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourServiceListComponent {
  readonly groups = input.required<TourCategoryGroup[]>();
  readonly selectedIds = input.required<Set<number>>();
  readonly disabledIds = input.required<Set<number>>();
  readonly plantTravelPills = input.required<Map<string, number>>();
  readonly widgetTemplates = input<CustomBookingMessageTemplate[]>([]);
  readonly lang = input<string>('en');

  readonly toggleService = output<number>();
  readonly viewAbsences = output<TourEligibleServiceDao>();

  pillKey(fromCategoryId: number, toCategoryId: number): string {
    return `${fromCategoryId}-${toCategoryId}`;
  }

  nextGroup(index: number): TourCategoryGroup | null {
    const groups = this.groups();
    return index < groups.length - 1 ? groups[index + 1] : null;
  }

  onToggle(serviceId: number): void {
    this.toggleService.emit(serviceId);
  }

  onViewAbsences(service: TourEligibleServiceDao): void {
    this.viewAbsences.emit(service);
  }
}
